import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.RequestModule.PaymentAmountIndicator', {
    warningText: 'Please note that payment amount exceeds amount due of the bill',
});
